import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["typography"],
  _excluded2 = ["children", "id", "label"];
import { cloneElement } from 'react';
import useUniqueId from 'react-utils/hooks/useUniqueId';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const customizeStyles = ({
  cssStyles
}) => {
  const {
      typography = {}
    } = cssStyles,
    restCssStyles = _objectWithoutPropertiesLoose(cssStyles, _excluded);
  return Object.assign({}, typography, restCssStyles);
};
const StyledInlineLabel = styled.label.withConfig({
  displayName: "InlineLabel__StyledInlineLabel",
  componentId: "sc-1qjeh0p-0"
})(({
  $cssStyles,
  theme
}) => {
  return Object.assign({
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: theme.space['300']
  }, $cssStyles);
});
const StyledLabelText = styled.div.withConfig({
  displayName: "InlineLabel__StyledLabelText",
  componentId: "sc-1qjeh0p-1"
})(({
  theme
}) => {
  return {
    flexShrink: '0',
    marginRight: theme.space['200'],
    userSelect: 'none'
  };
});
export const InlineLabel = _ref => {
  let {
      children,
      id,
      label
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  const defaultId = useUniqueId(`uiinlinelabel-`);
  const computedId = id || defaultId;
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps, {
    customizeStyles
  });
  return /*#__PURE__*/_jsxs(StyledInlineLabel, Object.assign({}, domProps, {
    id: computedId,
    $cssStyles: cssStyles,
    children: [/*#__PURE__*/_jsx(StyledLabelText, {
      children: label
    }), /*#__PURE__*/cloneElement(children, {
      'aria-labelledby': computedId
    })]
  }));
};